import {
  AllAnnualReviewsMentor,
  AllMentees,
  AllReviews,
  AssignedMentees,
  AssignedMenteesAnnual,
  MenteeObjective,
} from '../pages/mentor';
import QuarterlyReview from '../pages/quarterly-review';
import Layout from '../layout';
import ContentLayout from '../layout/contentLayout';
import MyObjective from '../pages/my-objectives';
import { UserRoles } from '../store/atom';
import {
  AnnualCycleEmployees,
  CreateAnnualReviewCycle,
  CreateCycle,
  EmployeeDashboard,
  ObjectiveDashboard,
  QuarterEmployees,
  QuarterlyReviews,
} from '../pages/hr';
import { Navigate } from 'react-router-dom';
import { MentorAnnualFeedback } from '../pages/mentor';
import { HRAnnualFeedback } from '../pages/hr';
import AllAnnualReviewCycles from '../pages/hr/all-annual-review-cycles/AllAnnualReviewCycles';
//import IndividualReviewCycle from '../pages/hr/all-annual-review-cycles/IndividualReviewCycle';

export enum Paths {
  AllMentees = '/mentor/assigned-mentees',
  QuarterlyReview = '/quarterly-reviews',
  //AllReviews = "/mentor/all-quarterly-reviews",
  AssignedMentees = '/mentor/all-quarterly-reviews',
  MyProfile = '/my-profile',
  EmployeeDashboard = '/HR/employee-dashboard',
  //MentorEmployeeDashboard = '/mentor/employee-dashboard',
  HRAllReviews = '/HR/all-quarterly-reviews',
  EmployeesfortheQuarter = '/HR/all-quarterly-reviews',
  CreateCycleFromAllQuarter = '/HR/all-quarterly-reviews/create-new-review-cycle',
  CreateCycle = '/HR/create-new-review-cycle',
  //CreateAnnualReviewCycle = '/HR/create-annual-review-cycle',
  HRAllAnnualReviews = '/HR/all-annual-review-cycles',
  EmployeesfortheAnnual = '/HR/all-annual-review-cycles',
  MentorAllAnnualReviews = '/mentor/all-annual-review-cycles',
  MentorAnnualMentees = '/mentor/all-annual-review-cycles/assigned-mentees-for-the-year',
  MentorAnnualMenteesFeedback = '/mentor/all-annual-review-cycles/assigned-mentees-for-the-year',
  MentorAnnualFeedback = '/mentor/annual-feedback',
  HRAnnualFeedback = '/HR/annual-feedback',
}

enum Roles {
  HR = 'HR',
  Mentor = 'Mentor',
  Mentee = 'Mentee',
}

export const routes = (userRole: UserRoles) => {
  const children = [
    {
      path: Paths.AllMentees,
      element: (
        <ContentLayout>
          <AllMentees />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: `${Paths.AllMentees}/:userName`,
      element: (
        <ContentLayout>
          <MenteeObjective />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: `${Paths.AllMentees}/:userName/annual-feedback`,
      element: (
        <ContentLayout>
          <MentorAnnualFeedback />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: `${Paths.QuarterlyReview}/:username`,
      element: (
        <ContentLayout>
          <QuarterlyReview />
        </ContentLayout>
      ),
      key: Roles.Mentee,
    },
    {
      path: `${Paths.MentorAnnualFeedback}/:username`,
      element: (
        <ContentLayout>
          <MentorAnnualFeedback />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: Paths.AssignedMentees,
      element: (
        <ContentLayout>
          <AllReviews />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: `${Paths.AssignedMentees}/:quarter`,
      element: (
        <ContentLayout>
          <AssignedMentees />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: `${Paths.AssignedMentees}/:quarter/:user`, // `${Paths.MentorEmployeeDashboard}/:username`,
      element: (
        <ContentLayout>
          <MenteeObjective />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: `${Paths.MentorAllAnnualReviews}/:quarter/:user`, // `${Paths.MentorEmployeeDashboard}/:username`,
      element: (
        <ContentLayout>
          <MenteeObjective />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: `${Paths.MentorAllAnnualReviews}`, // `${Paths.MentorEmployeeDashboard}/:username`,
      element: (
        <ContentLayout>
          <AllAnnualReviewsMentor />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: `${Paths.MentorAnnualMentees}`,
      element: (
        <ContentLayout>
          <AssignedMenteesAnnual />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: `${Paths.MentorAnnualMenteesFeedback}/:username/annual-feedback`,
      element: (
        <ContentLayout>
          <MentorAnnualFeedback />
        </ContentLayout>
      ),
      key: Roles.Mentor,
    },
    {
      path: Paths.MyProfile,
      element: (
        <ContentLayout>
          <MyObjective />
        </ContentLayout>
      ),
      key: Roles.Mentee,
    },
    {
      path: Paths.EmployeeDashboard, // <EmployeeDashboard />
      element: (
        <ContentLayout>
          <EmployeeDashboard />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: `${Paths.EmployeeDashboard}/:username`, // <EmployeeDashboard />
      element: (
        <ContentLayout>
          <ObjectiveDashboard />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: `${Paths.EmployeeDashboard}/:username/annual-feedback`,
      element: (
        <ContentLayout>
          <HRAnnualFeedback />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: Paths.HRAllReviews, // <QuarterlyReviews />
      element: (
        <ContentLayout>
          <QuarterlyReviews />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: `${Paths.HRAllReviews}/:username`, // <QuarterEmployees />
      element: (
        <ContentLayout>
          <QuarterEmployees />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: `${Paths.HRAllReviews}/:quarter/:user`, //`${Paths.EmployeeDashboard}/:username`,
      element: (
        <ContentLayout>
          <ObjectiveDashboard />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: Paths.CreateCycle,
      element: (
        <ContentLayout>
          <CreateCycle />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: Paths.CreateCycleFromAllQuarter,
      element: (
        <ContentLayout>
          <CreateCycle />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: Paths.HRAllAnnualReviews,
      element: (
        <ContentLayout>
          <AllAnnualReviewCycles />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: `${Paths.HRAllAnnualReviews}/:reviewName`,
      element: (
        <ContentLayout>
          <AnnualCycleEmployees />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: `${Paths.HRAllAnnualReviews}/:reviewName/:username`,
      element: (
        <ContentLayout>
          <ObjectiveDashboard />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: `${Paths.HRAllAnnualReviews}/:reviewName/:username/annual-feedback`,
      element: (
        <ContentLayout>
          <HRAnnualFeedback />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: `${Paths.HRAllAnnualReviews}/create-annual-review-cycle`,
      element: (
        <ContentLayout>
          <CreateAnnualReviewCycle />
        </ContentLayout>
      ),
      key: Roles.HR,
    },
    {
      path: '/',
      element: (
        <ContentLayout>
          <MyObjective />
        </ContentLayout>
      ),
      key: Roles.Mentee,
    },
    {
      path: '*',
      element: <Navigate to={Paths.MyProfile} replace />,
      key: Roles.Mentee,
    },
  ].filter((c) => {
    if (
      userRole.isHR === false &&
      userRole.isMentor === false &&
      (c.key === Roles.Mentor || c.key === Roles.HR)
    )
      return false;
    if (userRole.isMentor === false && c.key === Roles.Mentor) return false;
    if (userRole.isHR === false && c.key === Roles.HR) return false;
    return true;
  });

  return [
    {
      path: '/',
      element: <Layout />,
      children: children,
    },
  ];
};
